import React, { Fragment, ReactNode } from "react";

import styled from "styled-components";

const StyledHiglightedText = styled.span`
  background-color: var(--color-primary-200);
`;

StyledHiglightedText.displayName = "StyledHiglightedText";

const useHighlightText = (
  text: string,
  searchBy: string,
  matchCase = false
): ReactNode => {
  let textComparator = text;
  let searchByComparator = searchBy;
  if (!text) return;

  if (!matchCase) {
    textComparator = text.toLowerCase();
    searchByComparator = searchBy.toLowerCase();
  }

  if (
    searchBy &&
    textComparator &&
    textComparator.indexOf(searchByComparator) >= 0
  ) {
    const beforeHighlighted = text.substring(
      0,
      textComparator.indexOf(searchByComparator)
    );
    const highLighted = text.substring(
      textComparator.indexOf(searchByComparator),
      textComparator.indexOf(searchByComparator) + searchBy.length
    );
    const afterHighlighted = text.substring(
      textComparator.indexOf(searchByComparator) + searchBy.length
    );

    return (
      <Fragment>
        {beforeHighlighted.replace(/ /g, "\u00a0")}
        <StyledHiglightedText className="c-option--text__highlight">
          {highLighted.replace(/ /g, "\u00a0")}
        </StyledHiglightedText>
        {afterHighlighted.replace(/ /g, "\u00a0")}
      </Fragment>
    );
  }

  return text;
};

export default useHighlightText;
